import { EventBus } from '../stores/EventBus';
import WOStore from '../stores/WorkOrderStore';
import ShopStore from '../stores/ShopStore';
import CurrentUserStore from '../stores/CurrentUserStore';
import { notification } from 'antd';
import * as Sentry from '@sentry/react';

class GlobalAttachmentService {
  constructor() {
    this.isInitialized = false;
    this.init();
  }

  init() {
    if (this.isInitialized) return;

    EventBus.$on('workOrders:saved', this.handleWorkOrderSaved.bind(this));

    this.isInitialized = true;
  }

  async handleWorkOrderSaved(savedWorkOrder) {
    const pendingAttachmentData = localStorage.getItem(
      'sftp-pending-attachment'
    );
    if (pendingAttachmentData) {
      try {
        const attachmentData = JSON.parse(pendingAttachmentData);

        const selectedId =
          attachmentData.selectedWorkOrder.id ||
          attachmentData.selectedWorkOrder.w_ord_id ||
          attachmentData.selectedWorkOrder.invoice_number;
        const savedId =
          savedWorkOrder.id ||
          savedWorkOrder.w_ord_id ||
          savedWorkOrder.invoice_number;

        if (selectedId === savedId) {
          await this.linkWorkOrderToFile(savedWorkOrder, attachmentData.record);

          localStorage.removeItem('sftp-pending-attachment');
          localStorage.removeItem('sftp-attachment-state');
        } else {
          console.log('ID mismatch - not processing attachment');
        }
      } catch (error) {
        console.error('Error processing pending attachment:', error);
        localStorage.removeItem('sftp-pending-attachment');
      }
    } else {
      console.log('No pending attachment data found in localStorage');
    }
  }

  async linkWorkOrderToFile(savedWorkOrder, fileRecord) {
    try {
      const shopId = ShopStore.currentShop.id;
      const workOrderId =
        savedWorkOrder.w_ord_id || savedWorkOrder.invoice_number;

      const update = await WOStore.updateFileEvents({
        eventId: fileRecord.event_id,
        workOrderId: workOrderId,
        updatedBy: CurrentUserStore.user.email,
        shopId: shopId,
      });

      if (update && update.event_id) {
        notification.success({
          message: 'Work Order Attached Successfully',
          description: `Work order #${savedWorkOrder.invoice_number || savedWorkOrder.id} has been linked to the file.`,
        });
      } else {
        throw new Error('Failed to update file events');
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          component: 'GlobalAttachmentService',
          method: 'linkWorkOrderToFile',
        },
        extra: {
          savedWorkOrder,
          fileRecord,
        },
      });
      console.error('Error linking work order to file:', error);
      notification.error({
        message: 'Attachment Failed',
        description:
          'Failed to link the work order to the file. Please try again.',
      });
      throw error;
    }
  }

  cleanup() {
    if (this.isInitialized) {
      EventBus.$off('workOrders:saved', this.handleWorkOrderSaved);
      EventBus.$off('workOrders:created', this.handleWorkOrderCreated);
      this.isInitialized = false;
    }
  }
}

const globalAttachmentService = new GlobalAttachmentService();

export default globalAttachmentService;
